import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import { addCollection } from '@iconify/vue'
import biIcons from '@iconify-json/bi/icons.json'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

addCollection(biIcons)

createApp(App)
  .use(i18n)
  .use(createBootstrap())
  .use(router)
  .mount('#app')
